import type { ApprovalTableItemData } from '../../types/approversTable.js';

const OPERATION_TYPE = 'operation';

/**
 * Returns labels for all entities (users and roles) in the given field,
 * excluding operation-type entries (e.g. "then", "and", "or").
 */
export function getEntityLabels(
  data: ApprovalTableItemData | null | undefined,
  field: 'requesters' | 'approvers',
): string[] {
  if (!data?.[field] || !Array.isArray(data[field])) {
    return [];
  }
  return data[field].reduce<string[]>((acc, item) => {
    if (item.type !== OPERATION_TYPE && typeof item.label === 'string') {
      acc.push(item.label);
    }
    return acc;
  }, []);
}

/**
 * Collects unique user labels from all row data for a given field.
 */
export function getUniqueEntityLabels(
  rowData: ApprovalTableItemData[],
  field: 'requesters' | 'approvers',
): string[] {
  const set = new Set<string>();
  for (const row of rowData) {
    for (const label of getEntityLabels(row, field)) {
      set.add(label);
    }
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b));
}
